<script setup>
import { useI18n } from 'vue-i18n';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import Auth from 'dashboard/api/auth';

const { t } = useI18n();

const handleLogout = () => {
  Auth.logout();
};
</script>

<template>
  <div
    class="flex flex-col flex-1 items-center justify-center w-full h-full gap-6 bg-n-slate-2"
  >
    <EmptyState
      :title="t('APP_GLOBAL.NO_ACCESS.TITLE')"
      :message="t('APP_GLOBAL.NO_ACCESS.MESSAGE')"
    />
    <NextButton
      variant="faded"
      color="slate"
      :label="t('APP_GLOBAL.NO_ACCESS.LOGOUT')"
      @click="handleLogout"
    />
  </div>
</template>
